// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"222771fa","365":"95bb03c3","723":"93bc0779","757":"42690df8","882":"8690b4ae"}[chunkId] + ".chunk.css";
};